import { createAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { complaintPositionSlice } from '../complaintPosition/ComplaintPositionSlice';

const initialState = {
  positions: [],
  allowMultiplePositionsForComplaint: true,
};
export const editPosition = (id, updatePosition) =>({
  type: 'positions/edit',
  payload: {id, updatePosition}
})


const complaintPositionsSlice = createSlice({
  name: 'complaintPositions',
  initialState,
  reducers: {
    addComplaintPosition: (state, action) => {
      const { payload } = action;
      const newPosition = { ...payload, id: state.positions.length + 1 };
      state.positions.push(newPosition);
    },
    addSingleComplaintPosition: (state, action) => {
      const { payload } = action;
      const maxId = state.positions.reduce((max, position) => Math.max(max, position.id), 0);
      const newPosition = {
        ...payload,
        id: maxId + 1,
        productDisplayName: payload.product.name,
        quantityCorrectionsProposalDisplayName: payload.quantityCorrectionsProposal.displayName
      };
      state.positions = state.positions.concat(newPosition);
    },
    updateComplaintPosition: (state, action) => {
      const { id, ...updatedPositionData } = action.payload;
      const positionIndex = state.positions.findIndex(pos => pos.id === id);
      if (positionIndex !== -1) {
        state.positions[positionIndex] = { ...state.positions[positionIndex], ...updatedPositionData };
      }
    },
    editComplaintPosition: (state, action) => {
      state.positions = state.positions.map(item=>{
        if(item.id !== action.payload.id){
          return item;
        }
        return{
          ...item,
          ...action.payload,
        };
      });
    },

    editPosition: (state, action) => {
      const { id, updatedPosition } = action.payload;
      const index = state.positions.findIndex((position) => position.id === id);
      if (index !== -1) {
        state.positions[index] = { ...state.positions[index], ...updatedPosition };
      }
    },
    deleteComplaintPosition: (state, action) => {
      const positionIdToDelete = action.payload;
      state.positions = state.positions.filter(position => position.id !== positionIdToDelete);
    },
    setPositions: (state,action) =>{
      state.positions = action.payload;
    },
    updatePositionsData: (state, action) =>{
      return {...state, ...action.payload}
    },
    clearComplaintPositions: (state) =>{
      state.positions = [];
    },
    removeFileFromPositions: (state, action) => {
      const { positionId, index } = action.payload;
      const position = state.positions.find(position => position.id === positionId);
    
      if (position) {
        if (position.files && index >= 0 && index < position.files.length) {
          position.files.splice(index, 1);
        }
      }
    }
  }}
); 

export const {
  addComplaintPosition,
  addSingleComplaintPosition,
  deleteComplaintPosition,
  updateComplaintPosition,
  editComplaintPosition,
  setPositions,
  updatePositionsData,
  clearComplaintPositions,
  removeFileFromPositions
  
} = complaintPositionsSlice.actions;

export default complaintPositionsSlice.reducer;